import React, {useEffect} from "react";
import Footer from "../../components/Footer";
import ToolsSellBanner from "./ToolsSellBanner";
import ToolsSellBody from "./ToolsSellBody";
import Cta from "../../components/Cta";
import {useDocTitle} from "../../components/CustomHook";

const ToolsSellPage = () => {
    useDocTitle('Predaj elektrického náradia - M&rivet s.r.o.')

    useEffect(() => {
        window.scrollTo({top: 0, behavior: "smooth"});
    }, []);
    return (
        <>
            <ToolsSellBanner/>
            <ToolsSellBody/>
            <Cta/>
            <Footer/>
        </>
    );
};

export default ToolsSellPage;
